import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ModalRightService } from '../../../../../services/modal-right/modal-right.service';
import { ParametreDocumentStateService } from '../../../../../services/parametre-document/parametre-document-state.service';
import { PARAMETRE_TYPE_DOCUMENT_ACHAT } from '../../../../../services/parametre-document/parametre-document-type-ids';
import { VenteAchatParametreRow } from '../../../../../services/parametre-document/parametre-document-settings.service';
import { isTruthyTinyInt } from '../../../../../services/parametre-document/parametre-doc-api-normalize';

@Component({
    selector: 'app-doc-achat-inventaire',
    templateUrl: './doc-achat-inventaire.component.html',
    styleUrls: ['./doc-achat-inventaire.component.scss']
})
export class DocAchatInventaireComponent implements OnInit {
    private readonly typeId = PARAMETRE_TYPE_DOCUMENT_ACHAT.inventaire;

    isCustomizerOpen = false;
    customizerWidth = '0%';

    showTotals = true;
    showContactInfo = true;
    showDescription = false;
    noteText = '';

    saving = false;

    constructor(
        private router: Router,
        private customizerService: ModalRightService,
        private state: ParametreDocumentStateService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.state.ensureLoaded().subscribe({
            next: () => this.applyRowFromState(),
            error: () => this.toastr.error('Impossible de charger les paramètres.', 'Erreur')
        });
    }

    private applyRowFromState(): void {
        const row = this.state.getRowOrDefault(this.typeId, 'achat');
        this.showTotals = isTruthyTinyInt(row.aff_montant_totaux);
        this.showContactInfo = isTruthyTinyInt(row.aff_inf_contact);
        this.showDescription = isTruthyTinyInt(row.aff_courte_desp);
        this.noteText = row.note ?? '';
    }

    private buildPatch(): Partial<VenteAchatParametreRow> {
        return {
            aff_montant_totaux: this.showTotals ? 1 : 0,
            aff_inf_contact: this.showContactInfo ? 1 : 0,
            aff_courte_desp: this.showDescription ? 1 : 0,
            note: this.noteText || null
        };
    }

    saveParametreDocument(): void {
        this.saving = true;
        this.state
            .saveWithVenteAchatPatch(this.typeId, 'achat', this.buildPatch())
            .pipe(finalize(() => (this.saving = false)))
            .subscribe({
                next: () => this.toastr.success('Paramètres enregistrés.', 'Succès'),
                error: (err) => {
                    const msg = err?.error?.message ?? err?.message ?? 'Erreur serveur';
                    this.toastr.error(msg, 'Enregistrement');
                }
            });
    }

    appercue(): void {
        this.customizerService.open({
            showTotals: this.showTotals,
            showContactInfo: this.showContactInfo,
            showDescription: this.showDescription,
            noteText: this.noteText
        });
    }

    goToMain(): void {
        this.router.navigate(['/main/parametre/document/achat']);
    }
}
